import { ToolsFrame } from "../../styles";
import React from "react";
import { Redirect } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_TOOL_URL } from "../../queries";
import { isMobile } from "react-device-detect";
import WarningBanner from "../../../../../WarningBanner";

export default function PGAModel() {
  const { data, loading, error } = useQuery(GET_TOOL_URL, {
    variables: { name: "PGA Model" },
  });

  if (loading) return <></>;
  if (error) {
    return <Redirect to="/memberships" />;
  }
  return (
    <>
      <WarningBanner active={true}>
        <strong>
          You are using the old version of this tool.{" "}
          <a href="/tools/pga-model">
            Click here to use to the new model builder.
          </a>
        </strong>
      </WarningBanner>
      <ToolsFrame
        src={data.toolUrlByName.url}
        name="toolsFrame"
        scrolling="yes"
        marginHeight="0px"
        marginWidth="0px"
        allowFullScreen=""
        frameBorder="0"
      />
    </>
  );
}
